define('score_bootstrap/Components/ContentSearch/SearchBox',[
    "jquery",
    "knockout",
    "eventManager",
    "score_bootstrap/Models/Search/SuggestionSection",
    "score_bootstrap/Models/Search/SearchRequest",
    "score_bootstrap/Utils/UrlHelper",
    "score_bootstrap/Events/SearchRequestChangeEvent",
    "typeahead"
], function (
    $,
    ko,
    eventManager,
    SuggestionSection,
    SearchRequest,
    urlHelper,
    SearchRequestChangeEvent
) {
    "use strict";

    function SearchBox(scope, language, indexName, searchApiUrl, flags) {
        var $input = $(".js-typeahead :text", scope),
            $clearInputButton = $('.clear-input', scope),
            $button = $("a", scope),
            datasets = [],
            searchRequest = new SearchRequest(),
            timeout;

        this.$input = $input;
        this.$clearInputButton = $clearInputButton;

        $(".score-suggestion-section", scope).each(function parseSuggestionSection() {
            var suggestion = new SuggestionSection(this, language, indexName, searchApiUrl, flags);
            datasets.push(suggestion.typeaheadOptions);
        });

        function performSearch() {
            var val = $input.val(),
                url = urlHelper.setUrlParameters($button[0], "q", val);

            // Reload the page in case if enter press and page url was not changed.
            if (window.location.href === url) {
                window.location.reload(!0);
            } else {
                window.location = url;
            }
        }


        this.doSearch = performSearch;

        $input.typeahead(null, datasets);

        // attach to selections in the typeahead
        $input.on('typeahead:selected', function (ignore /*evt*/, data) {
            $input.on('change').unbind();
            window.location = data.Url;
            return false;
        });

        // attach to enter key
        $input.on("keyup", function (e, data) {
            if (e.keyCode === 13 && !data) {
                performSearch();
            }
            return false;
        }.bind(this));
        
        this.query = ko.observable(searchRequest.query);
        $input.typeahead('val', this.query());

        this.query.subscribe(function onQueryChange(query) {
            searchRequest.query = query;
            if (timeout) {
                clearTimeout(timeout);
            }

            timeout = setTimeout(function() {
                eventManager.trigger(SearchRequestChangeEvent.queryChange, query);
            }, 400);
        });
        
        ko.applyBindings(this, scope);
    }

    SearchBox.prototype.resetSearch = function () {
        this.query('');
        this.doSearch();
    }

    SearchBox.init = function init(args) {
        return args.IsEditorEditing === true ? null :
            new SearchBox(args.scope, args.Language, args.IndexName, args.SearchApiUrl, args.SearchFlags);
    };

    return SearchBox;
});
